import { Component, HostListener, Input, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'repeater',
  templateUrl: './repeater.component.html',
  styleUrls: [
    '../../../../assets/css/formatter.css',
    './repeater.component.css',
  ],
})
export class RepeaterComponent implements OnInit {
  @Input() paragraph: any;

  constructor() { }

  ngOnInit(): void {
    const reusableParagraphs =
      this.paragraph?.entity.fieldReusableParagraphs.map(
        ({ entity }) => entity
      );
    this.paragraph = {
      fieldWysiwygModContent: {
        value: reusableParagraphs
          ?.map(({ fieldWysiwygModContent }) => fieldWysiwygModContent?.value)
          ?.join(''),
      },
    };
  }
}
